import { LocalStorageChangeEvent } from "../common/constants";
export var storageAvailable = function storageAvailable(type) {
  try {
    var storage = window[type];
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
};
export var localStorageAvailable = function localStorageAvailable() {
  return storageAvailable('localStorage');
};
export var getItemFromLocalStorage = function getItemFromLocalStorage(key) {
  return localStorageAvailable() && localStorage.getItem(key);
};
export var setItemToLocalStorage = function setItemToLocalStorage(key, value) {
  if (storageAvailable('localStorage')) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }
  var event = new CustomEvent(LocalStorageChangeEvent);
  event.key = key;
  event.value = value;
  document.dispatchEvent(event);
};
export var removeItemFromLocalStorage = function removeItemFromLocalStorage(key) {
  return localStorageAvailable() && localStorage.removeItem(key);
};